<template>
  <el-form ref="form" :model="formData" :rules="rules" size="small">
    <el-row>
      <el-form-item
        :label="$l('INDEX.form_label_ecom_amz_store') || '店铺'"
        prop="storeCode"
      >
        <dict-select
          v-model="formData.storeCode"
          :placeholder="
            $l('INDEX.form_placeholder_ecom_amz_store') || '请选择店铺'
          "
          url="/ecom/amz/store/select"
          :selectedLabel.sync="formData.storeName"
          filterable
          clearable
        ></dict-select>
      </el-form-item>
    </el-row>
    <el-row class="mt-2">
      <el-upload
        drag
        action="#"
        :file-list="listFile"
        :auto-upload="false"
        :on-change="onFileChange"
        :on-remove="() => (listFile = [])"
        accept=".csv,.xlsx,.txt"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或' }}
          <em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
        </div>
      </el-upload>
    </el-row>
  </el-form>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
const fileTypes = [
  'ORDER',
  'INV',
  'SKU',
  'FIN',
  'AD',
  'ALLLISTING',
  'ACTIVELISTING',
]
export default {
  mixins: [EditLoading],
  props: { fileType: { type: String, default: '' } },
  data() {
    return {
      formData: { storeCode: '', storeName: '' },
      listFile: [],
      rules: {
        storeCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_ecom_amz_store') || '请选择店铺',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    onFileChange(file) {
      this.listFile = [file]
    },
    async upload() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (!this.fileType) {
        throw new Error(
          'file-type value is null, value: ORDER/INV/SKU/FIN/AD/ALLLISTING/ACTIVELISTING .'
        )
      }
      if (!fileTypes.includes(this.fileType)) {
        throw new Error(
          'file-type no value exists, value: ORDER/INV/SKU/FIN/AD/ALLLISTING/ACTIVELISTING .'
        )
      }

      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: this.$l('INDEX.tips_upload_file') || '请选择需要上传的文件',
          type: 'warning',
        })
        return false
      }
      const { raw, name: originalFileName } = this.listFile[0]
      this.loadingOpen()
      const uploadRes = await this.$api.SYS_UPLOAD(raw).catch(() => null)
      const { status: uploadStatus, body } = uploadRes || {}
      if (200 !== uploadStatus) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        return
      }
      const { fileId: fileMd5, url: fileUrl } = body
      const params = {
        fileMd5,
        fileUrl,
        originalFileName,
        ...this.formData,
        fileType: this.fileType,
      }

      const res = await this.$api.ecomAmzFileUploadApi(params).catch(() => null)
      const { status } = res || {}
      this.loadingClose()
      if (200 !== status) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.$emit('close')
      this.$emit('reload')
    },
  },
}
</script>
